import { Box, Typography } from '@mui/material';
import { Order } from '../../../interfaces/Order/Order';
import { sharedStyles } from '../../../utils/Style';

interface CustomerCellProps {
  order: Order;
}

export const CustomerCell = (props: CustomerCellProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
      <Typography sx={{ ...sharedStyles.body2 }}>
        {`${props.order.customerFirstName} ${props.order.customerLastName}`}
      </Typography>

      <Typography sx={{ ...sharedStyles.body2, fontWeight: 'bold' }}>
        {props.order.customerCompany ?? 'Misafir'}
      </Typography>

      <Typography sx={{ ...sharedStyles.body2 }}>
        {`${props.order.previousOrderCount + 1}. sipariş`}
      </Typography>
    </Box>
  );
};
